import axiosInstanceForActivityTracker from './axiosInstanceForActivityTracker';

export const getActivityInfo = async activityCode => {
  try {
    const res = await axiosInstanceForActivityTracker.get(`/activity/${activityCode}`, {
      data: null,
    });
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
